import styled, { css } from 'styled-components';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './game.default.box';
import {SWIPER_MODE} from '../../../css-constants';
import {LOBBY_PAGE} from '../../../../../themes/css-global-classes';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';

const common = css`
    ${({theme}) => theme.font.presets.bold};
`;

const PcBox = styled(BasePcBox)`
    ${common}
    margin-bottom: 5.5rem;

    .${SWIPER_MODE} &{
        height:24rem;
    }

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        .${LOBBY_PAGE} &  {
            width:14.25%;
            padding: 0 1%;
        }
    }

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        .${SWIPER_MODE} & {
            height:22rem;
        }
    }
`;

const MobileBox = styled(BaseMobileBox)`
    ${common}

    margin-bottom: 0;

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        .${SWIPER_MODE} &{
            height: 18rem;
        }
    }

    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        .${SWIPER_MODE} &{
            height: 26rem;
        }
    }
`;

export const GameCasino777Box = styledByDevice(PcBox, MobileBox);